import React from 'react';
import { Box, Typography } from '@mui/material';

function LabelsAppTest() {
  console.log('LabelsAppTest rendering...');
  
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4">
        Labels App Test - This should be visible
      </Typography>
      <Typography variant="body1">
        If you can see this, the route is working but there's an issue with the main component.
      </Typography>
    </Box>
  );
}

export default LabelsAppTest;
